import { isDefined } from 'common/lib/data';

type WithId = {
  id: string;
};

/*
 * returns a new array in the requested order.
 * If newOrder contains duplicate ids, the object will be duplicated in the returned array.
 * Ids which are not present in items are ignored.
 */
export const reorderItems = <T extends WithId>(items: T[], newOrder: string[]): T[] => {
  return newOrder
    .map(id => {
      return items.find(o => o.id === id);
    })
    .filter(isDefined);
};
